import { render } from "preact";
import { useEffect, useState } from "preact/hooks";
import "./index.css";
import { LandingPage } from "./landing-page";
import { CareerCompass } from "./career-compass";
import { AuthoredLinks } from "./types/quiz";

function Root() {
  const [started, setStarted] = useState(false);
  const [authorLinks, setAuthorLinks] = useState<AuthoredLinks>();

  // Fetch authored data on mount
  useEffect(() => {
    const authoredJson = document.getElementById('career-quiz-data');

    if (authoredJson) {
      try {
        const jsonData = JSON.parse(authoredJson.textContent || '');
        setAuthorLinks(jsonData);
      } catch(e) {}
    }
  }, []);

  return started ? <CareerCompass authoredLinks={authorLinks} setStarted={setStarted} /> : <LandingPage setStarted={setStarted} />;
}

render(<Root />, document.getElementById("career-quiz")!);
